import React from 'react';
import { useSelector,useDispatch } from 'react-redux';
import {
  getTechnicians,
  getCanEditJob,
  getJobType,
  getTreatmentType,
  getCalculatedMbkg,
  getCurrentJob,
  getTreatmentTypeDetails,
  getCovered,
  getStockLocation,
  getMBBottles,
  getFumigantList,getJas
} from '../selectors';
import TreatmentResultRecordsStartDetailsSection from './TreatmentResultRecordsStartDetailsSection';
import {formValueSelector,change} from 'redux-form'
//import JobDetailsForm from '../jobdetails/JobDetailsForm';
import { jobDetailsForm } from './../../../../constants/FormConstants';   //import { jobDetailsForm } from '../../constants/FormConstants';

import * as jobActions from '../../../../actions/jobActions';
import { treatmentResultRecordsForm } from '../../../../constants/FormConstants';

const TreatmentResultRecordsStartDetailsContainer = (props) => {
  const dispatch = useDispatch();
//const state1 = useSelector((state)=>state)
  const technicians = useSelector(getTechnicians);
  const canEditJob = useSelector(getCanEditJob);
  const currentJob = useSelector(getCurrentJob);
  const jobType = useSelector(getJobType);
  const treatmentType = useSelector(getTreatmentType);
  const calculatedMbkg = useSelector(getCalculatedMbkg);
  const treatmentTypeDetails = useSelector(getTreatmentTypeDetails);
  const covered = useSelector(getCovered);
  const stockLocation = useSelector(getStockLocation);
  const mbBottles = useSelector(getMBBottles)||[];
  const fumigantDetails  = useSelector(getFumigantList||[]);
  const jas = useSelector(getJas)


  //const formValues = (state1=>formValueSelector('treatmentResultRecordsForm')(state1));
 // const formValues = (state1=>formValueSelector(treatmentResultRecordsForm)(state1));
  //const formValues = useSelector((state) => formValueSelector(treatmentResultRecordsForm)(state));
   // Access form values safely
  /* const formValuesSelector = formValueSelector(treatmentResultRecordsForm);
   const formValues = useSelector((state) => {
     // Conditional check to ensure the form and specific form data exist
     if (state.form && state.form[treatmentResultRecordsForm]) {
       // Using formValueSelector with specified form
       return formValuesSelector(state);
     }
     return {}; // Return empty object if the form hasn't been initialized
   });*/
 
  //console.log('formValues',formValues)
  const actions = {
    ...jobActions,
    changeFieldValue: (field, value) => dispatch(change(treatmentResultRecordsForm, field, value)),
  };
  

  return (
    <TreatmentResultRecordsStartDetailsSection
      //{...state}
      {...props}
      actions={actions}
      //formValues={formValues}
      technicians={technicians}
      canEditJob={canEditJob}
      currentJob={currentJob}
      jobType={jobType}
      treatmentType={treatmentType}
      calculatedMbkg={calculatedMbkg}
      treatmentTypeDetails={treatmentTypeDetails}
      covered={covered}
      stockLocation={stockLocation}
      mbBottles ={mbBottles}
      fumigantDetails = {fumigantDetails}
      jas = {jas}
    />
  );
};

export default TreatmentResultRecordsStartDetailsContainer;
